import React from 'react';
import { formatCurrency } from '../../utils/formatters';

export default function TripSummary({ declaredAmount, expenses }) {
  const totalExpenses = expenses.reduce((s, e) => s + Number(e.amount), 0);
  const profit = Number(declaredAmount || 0) - totalExpenses;
  const isProfit = profit >= 0;

  return (
    <div style={{
      background: isProfit ? 'var(--success-light)' : 'var(--danger-light)',
      border: `1px solid ${isProfit ? 'var(--success)' : 'var(--danger)'}`,
      borderRadius: 'var(--radius-md)', padding: '1rem', marginTop: '0.75rem',
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem', textAlign: 'center' }}>
        {[
          ['Revenue', formatCurrency(declaredAmount || 0), 'var(--brand-black)'],
          ['Expenses', formatCurrency(totalExpenses), 'var(--danger)'],
          ['Net Profit', formatCurrency(profit), isProfit ? 'var(--success)' : 'var(--danger)'],
        ].map(([l, v, c]) => (
          <div key={l}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--gray-500)', fontWeight: 600, marginBottom: '0.25rem' }}>{l}</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: '1.1rem', fontWeight: 700, color: c }}>{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}